"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiDialog from "../../../../components/dialog/UiDialog.vue";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiSubmit from "@/components/form/UiSubmit.vue";
import API from "@ym-framework/api-utils";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import i18n from "@/lang";
export class formController extends UiFormController {
  constructor() {
    super(...arguments);
    this.device_limit = "all_device_permanent";
    this.device_date = "unlimited";
    this.start_time = "";
    this.end_time = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("team_management.login_restrictions.dialog.equipment_limit.message"),
    trigger: "blur"
  }])
], formController.prototype, "device_limit", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("team_management.login_restrictions.dialog.time_limit.message"),
    trigger: "blur"
  }])
], formController.prototype, "device_date", 2);
let UserLoginLimit = class extends Vue {
  constructor() {
    super(...arguments);
    this.controller = new formController();
    this.userItem = [];
    this.dialogLoading = false;
  }
  open(arrItem) {
    return __async(this, null, function* () {
      this.userItem = arrItem;
      if (this.userItem.length === 1) {
        console.log(this.userItem[0]);
      }
      let _ids = [];
      for (let item of arrItem) {
        _ids.push(item.guid);
      }
      let response = yield API.post(`api://base.auth/api/v5/users/user_login_limit_list`, {
        user_guid_list: _ids
      });
      this.controller.device_limit = response.data.device_limit;
      this.controller.device_date = response.data.date_limit;
      this.controller.end_time = response.data.end_time_limit;
      this.controller.start_time = response.data.start_time_limit;
      this._limit_dialog.show();
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        let _ids = [];
        for (let item of this.userItem) {
          _ids.push(item.guid);
        }
        yield UiConfirm.confirm(
          this.$t("team_management.login_restrictions.dialog.comfirm_dialog.message"),
          this.$t("team_management.login_restrictions.dialog.comfirm_dialog.title"),
          {
            confirmButtonText: this.$t("team_management.login_restrictions.dialog.comfirm_dialog.confirm"),
            cancelButtonText: this.$t("team_management.login_restrictions.dialog.comfirm_dialog.cancel")
          }
        );
        let response = yield API.put(`api://base.auth/api/v5/users/user_login_limit`, {
          date_limit: this.controller.device_date,
          device_limit: this.controller.device_limit,
          start_time_limit: this.controller.start_time,
          end_time_limit: this.controller.end_time,
          user_guid_list: _ids
        });
        this._limit_dialog.hide();
        this.$message.success(this.$t("team_management.login_restrictions.dialog.comfirm_dialog.success_message"));
        this.$emit("success");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("login-limit-dialog")
], UserLoginLimit.prototype, "_limit_dialog", 2);
UserLoginLimit = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiForm,
      UiSubmit
    }
  })
], UserLoginLimit);
export {
  UserLoginLimit as default
};
